// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import type {HelsecoreContactProps} from "./helsecoreContact.d"

import React from 'react';
import { Contact } from "@dip/helsecore/src/components/parts/Contact/Contact";

export default function (props: Readonly<HelsecoreContactProps>): React.JSX.Element {
  return <Contact {...props} />;
}
